import HttpRequest from './HttpRequest'

class ProportionOfTerminationStatusAppealProvider extends HttpRequest {
  findAll (query) {
    return this.get('/proportion-of-termination-status-appeal/', query)
  }
}

export default ProportionOfTerminationStatusAppealProvider
